<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button v-auth="'sys:job:add'"  @click="handleEdit('',0)" type="primary" icon="el-icon-plus">{{$t('common.addNew')}}</el-button>
    </div>
    <el-table v-loading="loading"  border :data="jobLists" style="width: 100%" >
      <el-table-column :label="$t('job.jobName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.jobName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('job.jobClass')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.jobGroup }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('job.jobDes')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('job.jobDo')" width="320">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.jobClassName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('job.cron')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.cronExpression }}</span>
        </template>
      </el-table-column>
     <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <el-button type="text" v-if="scope.row.triggerState=='WAITING'" plain>{{$t('job.wait')}}</el-button>
          <el-button type="text" v-if="scope.row.triggerState=='PAUSED'" plain>{{$t('job.pause')}}</el-button>
          <el-button type="text" v-if="scope.row.triggerState=='ACQUIRED'" plain>{{$t('job.executed')}}</el-button>
          <el-button type="text" v-if="scope.row.triggerState=='BLOCKED'" plain>{{$t('job.block')}}</el-button>
          <el-button type="text" v-if="scope.row.triggerState=='ERROR'" plain>{{$t('job.error')}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button v-auth="'sys:job:edit'" size="mini" @click="handleEdit(scope.row,1)">{{$t("common.edit")}}</el-button>
          <el-button  v-auth="'sys:job:startOff'" size="mini" type="success" @click="handleTrigger(scope.row)">{{$t('job.startOff')}}</el-button>
          <el-button
            type="info"
            size="mini"
            @click="changeStatus(scope.row,1)"
            v-if="scope.row.triggerState=='WAITING'"
            v-auth="'sys:job:wait'"
          >{{$t('job.pauseJob')}}</el-button>
          <el-button
            type="success"
            size="mini"
            v-auth="'sys:job:pause'"
            @click="changeStatus(scope.row,0)"
            v-if="scope.row.triggerState=='PAUSED'"
          >{{$t('job.backJob')}}</el-button>
          <el-button size="mini" v-auth="'sys:job:delete'" type="danger" @click="handleDelete(scope.$index, scope.row)">{{$t("common.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item :label="$t('job.jobName')" prop="jobName" :label-width="formLabelWidth">
          <el-input v-model="form.jobName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('job.jobClass')" prop="jobGroup" :label-width="formLabelWidth">
          <el-input v-model="form.jobGroup" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('job.jobDes')" prop="description" :label-width="formLabelWidth">
          <el-input v-model="form.description" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('job.jobDo')" prop="jobClassName" :label-width="formLabelWidth">
          <el-input v-model="form.jobClassName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('job.cron')" prop="cronExpression" :label-width="formLabelWidth">
          <el-input v-model="form.cronExpression" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="submitData">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  jobList,
  addjobList,
  deljobList,
  stopjobList,
  triggerjobList
} from "@/api/sys/jobList";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      titleName: this.$t("common.edit"),
      jobLists: [],
      showEditBox: false,
      changeType: 1,
      formLabelWidth: "150px",
      currentPage:1,
      pageSize:10,
      totalSize:0,
      form: {
        jobName: "",
        jobGroup: "",
        cronExpression: "",
        jobClassName: "",
        description:''
      },
      loading:true,
    };
  },
  mounted() {
    this.getjobList();
   
  },
  methods: {
    getjobList() {
      jobList().then(res => {
        this.jobLists = res.result.list;
        this.totalSize = res.result.total;
        this.loading = false
      });
    },
    handleEdit(row, type) {
       let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = updateObject;
        this.titleName = this.$t("common.edit");
      } else {
        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew");
      }
      this.showEditBox = true;
    },
    changeStatus(pram,status) {
      let data = {
        jobName: pram.jobName,
        jobGroup: pram.jobGroup,
        status:status
      };
      stopjobList(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
          this.getjobList();
        }
      });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancle"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            let data ={
              jobName: row.jobName,
              jobGroup: row.jobGroup,
            }
            deljobList(data).then(res => {
              if (res.code == 0) {
                this.getjobList();
              }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t('common.conDelete')
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('common.canDele')
          });
        });
    },
    submitData() {
      if(this.changeType == 0){
        this.form.id = ""
      }else{
        this.form.id = this.form.id
      }
        addjobList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t('common.changeSu'),
              type: "success"
            });
          }
          this.getjobList();
        });

      this.showEditBox = false;
    },
    handleTrigger(row){
      let data ={
        jobGroup:row.jobGroup,
        jobName:row.jobName
      }
      this.$confirm(this.$t("job.confimStart"), "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancle"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            triggerjobList(data).then(res => {
             if(res.code == 0){

             }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("job.startSucc")
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('common.cancle')
          });
        });
    },
    handleSizeChange(val){
     this.pageSize = val;
     this.getjobList()
    },
    handleCurrentChange(val){
      this.currentPage = val;
       this.getjobList()
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>
